import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['index', 'paymentType']);
  const createPaymentItemMap = `createPaymentItemMap(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createPaymentItemMap} {
      id
    }
  }
`;
};
